import React from 'react';

const GlobalTab = ({ config, updateConfigValue }) => {
  return (
    <>
      <h3 style={{ fontSize: '1.125rem', fontWeight: '600', marginBottom: '1.5rem' }}>Globale Einstellungen</h3>
      <div style={{ display: 'grid', gap: '1rem', maxWidth: '600px' }}>
        <div className="form-group">
          <label className="form-label">Standard-Meereshöhe (m)</label>
          <input
            type="number"
            value={config.global.default_altitude ?? 500}
            onChange={(e) => updateConfigValue('global.default_altitude', parseInt(e.target.value))}
            className="form-input"
            min="0"
            max="4000"
            data-testid="default-altitude-input"
          />
          <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '0.25rem' }}>
            Wird verwendet wenn der Nutzer keine Meereshöhe angibt.
          </p>
        </div>
        <div className="form-group">
          <label className="form-label">Follow-up nach (Tage)</label>
          <input
            type="number"
            value={config.global.followup_days}
            onChange={(e) => updateConfigValue('global.followup_days', parseInt(e.target.value))}
            className="form-input"
            data-testid="followup-days-input"
          />
        </div>
        <div className="form-group">
          <label className="form-label">Max. Dateien</label>
          <input
            type="number"
            value={config.uploads.max_files}
            onChange={(e) => updateConfigValue('uploads.max_files', parseInt(e.target.value))}
            className="form-input"
            data-testid="max-files-input"
          />
        </div>
        <div className="form-group">
          <label className="form-label">Max. Dateigröße (MB)</label>
          <input
            type="number"
            value={config.uploads.max_size_mb}
            onChange={(e) => updateConfigValue('uploads.max_size_mb', parseInt(e.target.value))}
            className="form-input"
            data-testid="max-size-input"
          />
        </div>
      </div>
    </>
  );
};

export default GlobalTab;
